import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject, catchError, filter, switchMap, take, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

// Token refresh işlemini yönetmek için bir flag
let isRefreshing = false;
const refreshTokenSubject = new BehaviorSubject<string | null>(null);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const token = authService.token;

    let request = req;

    if (token) {
        request = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            // 401 hatası ve logout endpoint'i değilse token refresh dene
            if (error.status === 401 && !req.url.includes('/auth/logout') && !req.url.includes('/auth/refresh')) {
                return handle401Error(req, next, authService);
            }
            return throwError(() => error);
        })
    );
};

function handle401Error(req: HttpRequest<unknown>, next: HttpHandlerFn, authService: AuthService): Observable<HttpEvent<unknown>> {
    if (!isRefreshing) {
        isRefreshing = true;
        refreshTokenSubject.next(null);

        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) {
            isRefreshing = false;
            authService.logout();
            return throwError(() => new Error('No refresh token available'));
        }

        return authService.refreshToken().pipe(
            switchMap((response: any) => {
                isRefreshing = false;
                const newToken = response?.accessToken || response?.AccessToken;
                if (newToken) {
                    refreshTokenSubject.next(newToken);
                    // Orijinal request'i yeni token ile tekrar gönder
                    return next(addTokenToRequest(req, newToken));
                }
                authService.logout();
                return throwError(() => new Error('Token refresh failed'));
            }),
            catchError((err) => {
                isRefreshing = false;
                authService.logout();
                return throwError(() => err);
            })
        );
    } else {
        // Zaten refresh işlemi devam ediyor, yeni token'ı bekle
        return refreshTokenSubject.pipe(
            filter(token => token !== null),
            take(1),
            switchMap((token) => {
                if (!token) {
                    authService.logout();
                    return throwError(() => new Error('Token refresh failed'));
                }
                return next(addTokenToRequest(req, token));
            }),
            catchError((err) => {
                authService.logout();
                return throwError(() => err);
            })
        );
    }
}

function addTokenToRequest(req: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
    return req.clone({
        setHeaders: {
            Authorization: `Bearer ${token}`
        }
    });
}
